var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoom4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1213 2.90909C20.6568 2.90909 21.091 3.34324 21.091 3.87879V13.5758C21.091 13.8329 20.9888 14.0795 20.8069 14.2614L14.2615 20.8068C14.0796 20.9887 13.833 21.0909 13.5758 21.0909H3.87888C3.34333 21.0909 2.90918 20.6568 2.90918 20.1212V3.87879C2.90918 3.34324 3.34333 2.90909 3.87888 2.90909H20.1213ZM4.84857 19.1515H13.1743L19.1516 13.1742V4.84848H4.84857V19.1515Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoom4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/room_4.e38d93cf6a90bd8f28996aa06ffbe039.svg";